import React from "react";
import { Helmet } from "react-helmet-async";
import { Header, Footer } from "../components/Layout";

export default function MentionsLegales() {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>Mentions Légales | Azur Tech - Désinsectisation & Dératisation Nice</title>
        <meta name="description" content="Mentions légales du site azurtech06.fr — Azur Tech, entreprise de désinsectisation et dératisation à Nice (06). SIREN 821 012 630." />
        <link rel="canonical" href="https://azurtech06.fr/mentions-legales" />
      </Helmet>
      <Header />
      <section className="pt-28 md:pt-36 pb-16">
        <div className="container mx-auto px-4 max-w-3xl">
          <h1 className="text-3xl md:text-4xl font-bold text-[#0f172a] mb-8">Mentions légales</h1>
          <div className="space-y-8 text-gray-700">
            <div data-testid="ml-editeur">
              <h2 className="text-xl font-bold text-[#0f172a] mb-3">Éditeur du site</h2>
              <p>
                <strong>Azur Tech</strong> — Entreprise de désinsectisation, dératisation et désinfection<br />
                Adresse : 6 rue Miollis, 06000 Nice, France<br />
                SIREN : 821 012 630<br />
                Téléphone : <a href="tel:0764079535" className="text-emerald-600 hover:underline">07 64 07 95 35</a><br />
                Email : <a href="mailto:azur.tech3d@yahoo.com" className="text-emerald-600 hover:underline">azur.tech3d@yahoo.com</a>
              </p>
            </div>
            <div>
              <h2 className="text-xl font-bold text-[#0f172a] mb-3">Activité</h2>
              <p>
                Azur Tech est une entreprise spécialisée dans la lutte contre les nuisibles (désinsectisation,
                dératisation, traitement des punaises de lit, destruction de nids de guêpes et frelons, désinfection),
                certifiée Certibiocide, intervenant dans les Alpes-Maritimes (06), le Var Est (83) et en Île-de-France.
              </p>
            </div>
            <div>
              <h2 className="text-xl font-bold text-[#0f172a] mb-3">Hébergement</h2>
              <p>Ce site est hébergé par Emergent (emergent.sh).</p>
            </div>
            <div>
              <h2 className="text-xl font-bold text-[#0f172a] mb-3">Propriété intellectuelle</h2>
              <p>
                L'ensemble des contenus de ce site (textes, images, logo) est la propriété d'Azur Tech.
                Toute reproduction sans autorisation préalable est interdite.
              </p>
            </div>
            <div>
              <h2 className="text-xl font-bold text-[#0f172a] mb-3">Données personnelles</h2>
              <p>
                Les informations transmises via les formulaires de contact (nom, téléphone, email, message) sont
                utilisées uniquement pour répondre à votre demande de devis ou d'intervention. Elles ne sont ni
                revendues ni communiquées à des tiers. Conformément au RGPD, vous pouvez exercer vos droits d'accès,
                de rectification et de suppression en écrivant à azur.tech3d@yahoo.com.
              </p>
            </div>
            <div>
              <h2 className="text-xl font-bold text-[#0f172a] mb-3">Avis clients</h2>
              <p>
                Les avis affichés sur ce site proviennent de nos fiches officielles{" "}
                <a href="https://share.google/DUrON8BOcFKaDm6vA" target="_blank" rel="noopener noreferrer" className="text-emerald-600 hover:underline">Google Business Profile</a>
                , où ils peuvent être consultés et vérifiés.
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
